import { isFeatureEnabled } from './feature-toggles.module'
import QuizStatuses from '../../constants/QuizStatuses'
import VoteStep from '../../constants/VoteStep'

const UNLEASH_FLAG_LIVE_CERTIFICATES = 'AHA-49363-live-certificates'

const ANSWERABLE_SLIDE_TYPES = ['multipleChoice', 'imageChoice', 'scale', 'openEnded', 'wordCloud', 'ideas', 'pickAnswer']

const _state = {
  answeredSlideIds: [],
  shownCertificate: null,
}

const isAnswerable = (slide, rootGetters) => ANSWERABLE_SLIDE_TYPES.includes(slide.type)
  || Boolean(rootGetters.isQuizSlide?.(slide))

const hasAnswered = (slide, state, rootState, rootGetters) => Boolean(
  slide.isEndSlide
  || slide.openEndedSubmited
  || state.answeredSlideIds.includes(String(slide.id))
  || rootState.submitedQuiz?.slideSubmited?.[slide.id]
  || rootGetters['quiz/quizResultBySlide']?.(slide.id),
)

const isAnswerClosed = (slide) => Boolean(slide.stopSubmission)
  || slide.quizStatus === QuizStatuses.RESULT_SCREEN
  || (slide.type === 'ideas' && slide.votingStep === VoteStep.RESULT)

const isQuestionStillOpen = (slide, state, rootState, rootGetters) => isAnswerable(slide, rootGetters)
  && !hasAnswered(slide, state, rootState, rootGetters)
  && !isAnswerClosed(slide)

const _getters = {
  isLiveCertificatesEnabled: (_, __, ___, rootGetters) => Boolean(
    isFeatureEnabled(rootGetters, UNLEASH_FLAG_LIVE_CERTIFICATES),
  ),

  isLiveCertificateOn: (_, getters, rootState, rootGetters) => getters.isLiveCertificatesEnabled
    && Boolean(rootState.presentation?.liveCertificateEnabled)
    && !rootState.presentation.audiencePacing
    && !rootGetters?.['replay/isReplayCopy'],

  sessionType: (_, __, rootState) => (rootState.presentation?.audiencePacing ? 'self_paced' : 'live'),

  hasFinishedLastSlide: (state, getters, rootState, rootGetters) => {
    const slide = rootGetters.activeActivity
    return Boolean(
      getters.isLiveCertificateOn
      && slide?.id
      && rootGetters['slideProgress/isLastVisibleSlide']
      && !isQuestionStillOpen(slide, state, rootState, rootGetters),
    )
  },
}

const mutations = {
  showCertificate(state, certificate) {
    // eslint-disable-next-line no-param-reassign
    state.shownCertificate = certificate
  },
  dismissCertificate(state) {
    // eslint-disable-next-line no-param-reassign
    state.shownCertificate = null
  },
  setAnsweredSlideIds(state, slideIds) {
    // eslint-disable-next-line no-param-reassign
    state.answeredSlideIds = slideIds.map(String)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
}
